import { Link } from 'react-router-dom'

export default function BackButton({ to = '/experiments', label = 'Experiments' }) {
  return (
    <Link
      to={to}
      style={{
        position: 'fixed',
        top: 24,
        left: 28,
        zIndex: 1000,
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        textDecoration: 'none',
        fontFamily: "'JetBrains Mono', monospace",
        fontSize: 11,
        letterSpacing: '0.18em',
        textTransform: 'uppercase',
        color: 'rgba(255,255,255,0.7)',
        padding: '8px 14px',
        borderRadius: 999,
        background: 'rgba(255,255,255,0.08)',
        border: '1px solid rgba(255,255,255,0.12)',
        backdropFilter: 'blur(8px)',
        WebkitBackdropFilter: 'blur(8px)',
        transition: 'color 0.2s, background 0.2s',
      }}
      onMouseEnter={e => {
        e.currentTarget.style.color = 'rgba(255,255,255,1)'
        e.currentTarget.style.background = 'rgba(255,255,255,0.14)'
      }}
      onMouseLeave={e => {
        e.currentTarget.style.color = 'rgba(255,255,255,0.7)'
        e.currentTarget.style.background = 'rgba(255,255,255,0.08)'
      }}
    >
      <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
        <path d="M8 1L3 6L8 11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
      {label}
    </Link>
  )
}
